import { render, staticRenderFns } from "./AAsignacionTablarun.vue?vue&type=template&id=035c2e14"
import script from "./AAsignacionTablarun.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablarun.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablarun.vue?vue&type=style&index=0&id=035c2e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports